<template>
  <div class="row justify-content-center" style="">
    <div class="col-12 col-md-10 col-lg-8 col-xl-8">
      <div class="tit text-center">
        <img src="/static/assets/images/ico-smile.svg" alt="Icone feliz">
        <h1>Cadastro Concluído com sucesso</h1>
        <p>Agora, faremos uma análise e em até 24 horas você receberá uma resposta.</p>
        <p>Ah, não esqueça de preencher o formulário de suitability, ele é muito importante para mapear o seu perfil de investimento e indicarmos os produtos, serviços e operações mais adequadas às suas necessidades.</p>
      </div>
      <div class="text-center suitability-link-container">
        <router-link to="/informacoes-adicionais/suitabilityVerify" class="btn btn-sm btn-primary" title="Preencher formulário de suitability">Preencher Formulário de Suitability</router-link>
      </div>
      <div class="text-center">
        <a href="/" class="link" title="IOUU">
          <i class="ico-iouu" />
        </a>
        <p class="nome">Obrigado por nos escolher!</p>
        <p class="obs">Juntos vamos reinventar o sistema bancário ultrapassado e garantir um melhor negócio para todos.</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../../assets/styles/iouu/variables";
  @import "../../assets/styles/iouu/mixins";

  div > {
    i {
      margin-top: 50px;
      font-size: 100px;
      line-height: 60px;
      color: $c3;
    }
  }
  .tit {
    img {
      width: 80px;
      margin-bottom: 40px
    }
  }

  .suitability-link-container {
    margin: 5vh 0;
  }

  @include xs {
    .steps {
      .btn-primary {
        width: 100%;
        padding: 14px 0;
        font-size: calcRem(13);
      }
    }
  }
</style>

<script>
export default {
  beforeCreate() {
    this.$store.dispatch('updateUser')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationInvestor/PassoConcluido.vue